import { useContext } from "react";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import TruncateMarkup from "react-truncate-markup";
import { useNavigate } from "react-router-dom";
//Import from project
import "./classcard.scss";
import musicClassImage from "../../../../Assets/music-class.png";
import ClassAction from "./ClassAction";
import { AuthContext } from "../../../../Context/AuthContext";
import { Avatar, Box, Stack, Typography } from "@mui/material";

export default function ClassCard({ data, setRefetch }) {
  // Change Language
  const { t } = useContext(AuthContext);

  const navigate = useNavigate();

  const translateStatus = (status) => {
    const dataStatus = {
      complete: t("thead_completed"),
      studying: t("thead_studying"),
      dropout: t("thead_dropout"),
      stopout: t("thead_stopout"),
    };
    return dataStatus[status] ? dataStatus[status] : status;
  };

  return (
    <Box className="card">
      <Stack direction="column">
        <Box className={"status-card"}>
          <Stack direction="row" alignItems="center">
            <Typography className={data?.status}>
              <Box className="dot" />
              {translateStatus(data?.status)}
            </Typography>
          </Stack>
        </Box>

        <Box className="action">
          <ClassAction editData={data} setRefetch={setRefetch} />
        </Box>

        <Box>
          <img
            alt="loading..."
            src={data.classId.backgroundImage || musicClassImage}
            style={{
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px",
              width: "100%",
              height: "180px",
              objectFit: "cover",
            }}
          />
        </Box>
        {/* <Card sx={{ boxShadow: "none", marginTop: 2 }}>
          <CardMedia
            sx={{ objectFit: "scale-down" }}
            alt="loading..."
            image={musicClassImage}
            height="166"
            component="img"
          />
        </Card> */}

        <Box
          sx={{ padding: 2.5, paddingTop: 1.5 }}
          onClick={() =>
            navigate(
              `/student/student-detail/student-class-detail?classId=${data?.classId?._id}&studentId=${data?.studentId?._id}`,
            )
          }
        >
          <Stack spacing={1}>
            <Stack spacing={0.8}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                spacing={0.5}
              >
                <TruncateMarkup lines={1}>
                  <Typography className="card-title">
                    {data?.classId?.courseId?.enName +
                      " " +
                      data?.classId?.className}
                  </Typography>
                </TruncateMarkup>
                <Stack
                  direction="row"
                  spacing={1}
                  alignItems="flex-start"
                  justifyContent="center"
                >
                  <PeopleAltIcon sx={{ color: "#d24029", fontSize: 22 }} />
                  <Typography className="total-people">
                    {data?.totalStudent || 0}
                  </Typography>
                </Stack>
              </Stack>

              <TruncateMarkup lines={2}>
                <Typography className="description">
                  {data?.classId?.remark}
                </Typography>
              </TruncateMarkup>
            </Stack>

            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              justifyContent="space-between"
            >
              <Stack direction="row" spacing={1.3} alignItems="center">
                <Avatar
                  alt="Loading..."
                  src={data?.classId?.teacherId?.profile}
                />
                <Stack direction="column">
                  <Typography className="teacher-name">
                    {data?.classId?.teacherId?.familyName +
                      " " +
                      data?.classId?.teacherId?.userName}
                  </Typography>
                  <Typography className="position">
                    {data?.classId?.teacherId?.role}
                  </Typography>
                </Stack>
              </Stack>

              <Stack direction="column">
                {/* <Typography className="lesson">
                  {t("thead_lesson")} {data?.classId?.totalLesson}
                </Typography> */}
                <Typography className="lesson">
                  {t("thead_hour")} {data?.totalHour}
                </Typography>
                <Typography
                  className="lesson"
                  sx={{
                    color:
                      data?.totalRemainHour <= 5
                        ? "red !important"
                        : "orange !important",
                  }}
                >
                  {t("thead_remain")} {data?.totalRemainHour}
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
}
